/**
 * Tipos relacionados a Tenant — espelham o schema Prisma do backend.
 * SPEC-20260503-0528.
 */

export type TenantStatus = "PROVISIONING" | "ACTIVE" | "ARCHIVED";

export type BillingTier = "free" | "starter" | "pro" | "enterprise";

export interface Tenant {
  tenantKey: string;
  name: string;
  brandingColor: string | null;
  billingTier: BillingTier;
  status: TenantStatus;
  createdAt: string;
  archivedAt: string | null;
  metadata: Record<string, unknown>;
}

export interface TriggerOnboardingInput {
  tenantKey: string;
  name: string;
  brandingColor?: string;
  billingTier: BillingTier;
  idempotencyKey?: string;
}

export interface TriggerOnboardingResult {
  sagaId: string;
  sagaType: string;
  status: string;
  statusUrl: string;
  currentStep: number;
  totalSteps: number;
  tenantKey: string;
}

export interface ListTenantsParams {
  status?: TenantStatus;
  billingTier?: BillingTier;
  limit?: number;
  offset?: number;
}

export interface ListTenantsResult {
  data: Tenant[];
  pagination: { limit: number; offset: number; total: number };
}

export const BILLING_TIERS: BillingTier[] = ["free", "starter", "pro", "enterprise"];
export const TENANT_STATUSES: TenantStatus[] = ["PROVISIONING", "ACTIVE", "ARCHIVED"];
